<template>
  <b-sidebar v-model="localSidebar" id="sidebarRef" :title="'Ocorrencia nº ' + ocorrencia.id" right shadow width="80%"
    backdrop backdrop-variant="white">
    <b-row align-h="center" align-v="center" v-if="ocorrencia.id && localSidebar">
      <b-col class="col-md-10">
        <b-card>
          <b-card-header :class="getClass" v-if="ocorrencia.id">
            <b-row>
              <b-col>
                <h4>
                  <p>
                    <b>{{ tipoOcorrencia }}</b>
                  </p>
                </h4>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <p><b> Código da Ocorrência:</b> {{ ocorrencia.id }}</p>
              </b-col>
              <b-col>
                <p><b> Status:</b> {{ getStatus }}</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="9">
                <p>
                  <b> Distribuidor: </b>
                  {{ ocorrencia.distribuidor.codigo }} -
                  {{ ocorrencia.distribuidor.nome }}
                </p>
              </b-col>
              <b-col>
                <p><b>Classe:</b> {{ ocorrencia.distribuidor.classe }}</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="9" v-if="ocorrencia.revendedora">
                <p>
                  <b>Revendedora: </b>
                  {{
                    ocorrencia.revendedora ? ocorrencia.revendedora.nome : ""
                  }}
                </p>
              </b-col>
              <b-col v-if="ocorrencia.enviar_para">
                <p><b>Enviar Para:</b> {{ ocorrencia.enviar_para }}</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="col-md-2">
                <p><b>Lote:</b> {{ ocorrencia.lote.codigo }}</p>
              </b-col>
              <b-col class="text-right">
                <p>
                  <b> Abertura:</b> {{ formatarData(ocorrencia.created_at) }}
                </p>
              </b-col>
              <b-col class="text-right">
                <p>
                  <b> Última Atualização:</b>
                  {{ formatarData(ocorrencia.updated_at) }}
                </p>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col>
                <b> Arquivos de Lote </b>
              </b-col>
              <b-col cols="8" class="text-right" v-if="ocorrencia && ocorrencia.analista">
                <small> <b>Analista Responsável: </b> {{ ocorrencia.analista.name }} </small>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <button type="button" v-if="ocorrencia.lote.url_extrato" data-toggle="tooltip" data-placement="top"
                  title="Fatura por Revendedora" @click="getUrl(ocorrencia.lote.url_extrato)"
                  class="btn btn-info btn-sm mr-3">
                  <i class="fa fa-list-ol"></i>
                </button>
                <button type="button" data-toggle="tooltip" data-placement="top" title="Resumo de Pedido"
                  v-if="ocorrencia.lote.url_resumo" @click="getUrl(ocorrencia.lote.url_resumo)"
                  class="btn btn-primary btn-sm mr-3">
                  <i class="far fa-file-alt"></i>
                </button>
                <button type="button" data-toggle="tooltip" data-placement="top" title="Nota Fiscal"
                  v-if="ocorrencia.lote.url_nfe" @click="getUrl(ocorrencia.lote.url_nfe)"
                  class="btn btn-warning btn-sm mr-3">
                  <i class="fas fa-file-pdf"></i>
                </button>
                <button type="button" data-toggle="tooltip" data-placement="top" title="Nota Fiscal"
                  v-else-if="ocorrencia.lote.has_notas && ocorrencia.lote.has_notas.length > 0" @click="viewNota(ocorrencia.lote.codigo, 'nota')"
                  class="btn btn-warning btn-sm mr-3">
                  <i class="fas fa-file-pdf"></i>
                </button>
                <button type="button" data-toggle="tooltip" data-placement="top" title="Devolução"
                  v-if="ocorrencia.lote.url_devolve" @click="getUrl(ocorrencia.lote.url_devolve)"
                  class="btn btn-primary btn-sm mr-3">
                  <i class="fa fa-car"></i>
                </button>
              </b-col>
            </b-row>
            <b-row v-if="ocorrencia && ocorrencia.valor_max">
              <b-col cols="12" class="text-right">
                <small><b>Reembolso máximo: </b></small><small style="color: red;"> R$ {{
                  ocorrencia.valor_max.toString().replace('.', ',') }}</small>
              </b-col>
            </b-row>
          </b-card-header>
          <b-card-body>
            <v-mensagens v-if="ocorrencia.id" :ocorrenciaProps="ocorrencia" class="mt-3"
              @loadOcorrencias="loadOcorrencias"></v-mensagens>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-sidebar>
</template>

<script>
export default {
  name: "MensagensBar",
  props: {
    ocorrencia: {
      type: Object,
      default: {},
    },
    sidebar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localSidebar: this.sidebar,
      isVisible: false,
      optionsOc: []
      //ocorrencia: this.ocorrenciaProps
    };
  },
  watch: {
    sidebar(newVal) {
      this.localSidebar = newVal;
    },
    localSidebar(newVal) {
      this.$emit("update:sidebar", newVal);
      if (newVal == false) {
        this.$emit("ocorrencia", {});
      }
    },
  },
  computed: {
    getClass() {
      let classe = "";
      switch (this.ocorrencia.status) {
        case "EM ATENDIMENTO":
          classe = "ATENDIMENTO";
          break;
        case "SOLUCIONADO":
          classe = "SOLUCIONADO";
          break;
        case "PENDENTE":
          classe = "PENDENTE";
          break;
        case "FECHADO":
          classe = "FECHADO";
          break;
        case "NOVO":
          classe = "NOVO";
          break;
        case "CANCELADA":
          classe = "CANCELADA";
          break;
      }
      return classe;
    },
    tipoOcorrencia() {
      const vm = this;
      let tipo = "";
      if (vm.optionsOc.length > 0) {
        tipo = vm.optionsOc.find((el) => el.value == vm.ocorrencia.tipo)
      }
      return tipo && tipo.text ? tipo.text : "";
      // return tipo;
    },
    getStatus() {
      let status = this.ocorrencia.id ? this.ocorrencia.status : "NOVO";
      return status;
    },
  },
  mounted() {
    this.getTipoOcorrencias();
  },
  methods: {
    viewNota(codigo, tipo) {
      const params = {
        tipo: tipo,
        lote: codigo
      }
      axios.get('/get-link', { params: params })
        .then((response) => {
          window.open('/lote/nf/' + response.data.resource, '_blank');
        }).catch((error) => {
          console.log(error);
        })
    },
    getTipoOcorrencias() {
      const vm = this;
      axios.get('/ocorrencia/get/tipo-ocorrencia')
        .then((response) => {
          response.data.tipos.forEach((el) => {
            vm.optionsOc.push(el);
          })
        }).catch((error) => {
          console.log(error);
        })
    },
    getUrl(url) {
      window.open("/" + url, "_blank");
    },
    loadOcorrencias() {
      this.localSidebar = false;
      this.$emit("loadOcorrencias");
    },
    voltar() {
      window.location.href = "/ocorrencia";
    },
    formatarData(data) {
      return moment(data).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>

<style>
.NOVO {
  background-color: #bdfdbd;
}

/* #ABERTO {
  background-color: #00FFFF;
} */

.SOLUCIONADO {
  background-color: #cfe8ff;
}

.PENDENTE {
  background-color: #fffec5;
}

.FECHADO {
  background-color: #363636;
  color: #f1f9ff;
}

.ATENDIMENTO {
  background-color: #ffe4e1;
}

.CANCELADA {
  background-color: #fd7566;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ocorrencia/componente/MensagensBar.vue